import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyBEhBcp4nUgMej5UmYcNFLbzLprUeEWqoo",
  authDomain: "md-digital-card.firebaseapp.com",
  databaseURL: "https://md-digital-card-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "md-digital-card",
  storageBucket: "md-digital-card.firebasestorage.app",
  messagingSenderId: "262369464005",
  appId: "1:262369464005:web:f87cde0657259d89aa2aac",
  measurementId: "G-KGHWFRVLPX"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app);
export { auth, storage, database };
